import { LayoutModuleBold, StyleTwoPinMarkerBold } from '@ha/icons';
import { defineKey as T } from '@ha/intl';
import { SvgIconProps } from 'ha/ui/next/SvgIcon';

// The values are used in mixpanel
export enum MapViewState {
  noMap = 'noMap',
  fullMap = 'fullMap',
}

interface MapViewStateButton {
  Icon: React.ComponentType<SvgIconProps>;
  text: string;
  value: MapViewState;
}

export const mapControlsArray: MapViewStateButton[] = [
  {
    Icon: LayoutModuleBold,
    text: T('mapControls.gallery'),
    value: MapViewState.noMap,
  },
  {
    Icon: StyleTwoPinMarkerBold,
    text: T('mapControls.map'),
    value: MapViewState.fullMap,
  },
];
